import React from 'react';
import OrderQRCode from '../../components/OrderQRCode';
import { useNavigate } from 'react-router-dom';

interface OrderQRCodeProps {
  context?: string;
}

const OrderQRCodeScreen: React.FC<OrderQRCodeProps> = ({ context }) => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = React.useState<number>(1);

  React.useEffect(() => {
    if (countdown > 0) {
      const timer = setInterval(() => {
        setCountdown((prev: number) => (prev > 0 ? prev - 1 : 0));
      }, 1000);
      return () => clearInterval(timer);
    }
    if (countdown === 0) {
      window.location.href = '/';
    }
  }, [countdown]);

  React.useEffect(() => {
    setCountdown(60);
  }, []);

  const handleStartNewOrder = () => {
    navigate('/choose-your-menu');
  };

  return (
    <OrderQRCode redirectCountdown={countdown} handleStartNewOrder={handleStartNewOrder} context={context} />
  );
};

export default OrderQRCodeScreen;
